import {PaginatedContent} from '../../../application/contentLoaders/paginatedContent';
import {ReadyProvider} from '../../../application/providers/readyProvider';

ReadyProvider.executeOnReady(() => {
    let pageContent = new PaginatedContent(document.querySelector('[data-page="content"]'));
    let sortingFilter = document.querySelectorAll('[data-filter="sorting"]');

    if (sortingFilter) {
        Array.from(sortingFilter).forEach((element) => element.addEventListener('click', (event) => {
            pageContent.setFilter('sort', event.currentTarget.value);
            pageContent.reload();
        }));
    }
});
